angular.module('bb.util').component('bbToasts', {
  controller: ToastController,
  controllerAs: 'vm',
  template: require('./toasts.html'),
});

ToastController.$inject = ['ToastService'];

function ToastController(ToastService) {
  const vm = this;
  vm.toasts = ToastService.toasts;
  vm.remove = function (id) {
    ToastService.remove(id);
  };
}

export {};
